/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  return function onChange(value) {
    props.onSortChange(props.stageId, value.selected)
  }
}
